module.exports = __webpack_public_path__ + "img/symbol_14_free.a3455bfc.png";